import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { HashRouter as Router } from 'react-router-dom';
import ScrollToTop from './helpers/ScrollToTop.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ScrollToTop/>
    <App />
  </Router>
);